/* ============================================
   VEJI Header — scroll + menu mobile + cloche notifications
   Activé uniquement sur body.veji-page (templates VEJI).
   ============================================ */

(function () {
  'use strict';

  function init() {
    if (!document.body.classList.contains('veji-page')) {
      var retries = 0;
      var maxRetries = 30;
      var poll = function () {
        if (document.body.classList.contains('veji-page')) {
          setup();
        } else if (retries++ < maxRetries) {
          requestAnimationFrame(poll);
        }
      };
      requestAnimationFrame(poll);
      return;
    }
    setup();
  }

  function setup() {
    var nav = document.getElementById('veji-nav');
    var hamburger = document.getElementById('veji-nav-hamburger');
    var mobileMenu = document.getElementById('veji-nav-mobile-menu');

    if (!nav) return;

    /* ---------- Ombre au scroll ---------- */
    var scrolled = false;
    var threshold = 20;
    function onScroll() {
      var shouldScroll = window.scrollY > threshold;
      if (shouldScroll !== scrolled) {
        scrolled = shouldScroll;
        nav.classList.toggle('scrolled', shouldScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---------- Menu mobile ---------- */
    if (hamburger && mobileMenu) {
      var mobileLinks = mobileMenu.querySelectorAll('a');

      function openMenu() {
        hamburger.classList.add('active');
        hamburger.setAttribute('aria-expanded', 'true');
        hamburger.setAttribute('aria-label', 'Fermer le menu');
        mobileMenu.classList.add('open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        document.body.classList.add('veji-menu-open');
        mobileLinks.forEach(function (link) { link.setAttribute('tabindex', '0'); });
      }
      function closeMenu() {
        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', 'Ouvrir le menu');
        mobileMenu.classList.remove('open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('veji-menu-open');
        mobileLinks.forEach(function (link) { link.setAttribute('tabindex', '-1'); });
      }
      hamburger.addEventListener('click', function () {
        mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
      });
      mobileLinks.forEach(function (link) { link.addEventListener('click', closeMenu); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('open')) {
          closeMenu(); hamburger.focus();
        }
      });
      document.addEventListener('click', function (e) {
        if (mobileMenu.classList.contains('open') && !mobileMenu.contains(e.target) && !hamburger.contains(e.target)) {
          closeMenu();
        }
      });
    }

    /* ---------- Cloche notifications ---------- */
    var notif = nav.querySelector('[data-veji-notif]');
    if (notif) {
      var toggle = notif.querySelector('[data-veji-notif-toggle]');
      var panel = notif.querySelector('[data-veji-notif-panel]');
      var badge = notif.querySelector('[data-veji-notif-badge]');
      var items = notif.querySelectorAll('[data-notif-id]');
      var STORAGE_KEY = 'veji_seen_notifs';

      // ids actuellement affichés
      var currentIds = [];
      items.forEach(function (li) {
        var id = li.getAttribute('data-notif-id');
        if (id) currentIds.push(id);
      });

      function getSeen() {
        try {
          var raw = window.localStorage.getItem(STORAGE_KEY);
          var arr = raw ? JSON.parse(raw) : [];
          return Array.isArray(arr) ? arr : [];
        } catch (e) { return []; }
      }
      function saveSeen(arr) {
        try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (e) {}
      }
      function updateBadge() {
        var seen = getSeen();
        var unread = currentIds.filter(function (id) { return seen.indexOf(id) === -1; });
        var n = unread.length;
        if (n > 0) {
          badge.textContent = n > 9 ? '9+' : String(n);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
      function markAllSeen() {
        var seen = getSeen();
        currentIds.forEach(function (id) {
          if (seen.indexOf(id) === -1) seen.push(id);
        });
        // borne : ne garde que les ids encore présents (nettoyage)
        saveSeen(seen);
        updateBadge();
      }

      function openPanel() {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        markAllSeen();
      }
      function closePanel() {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.hidden ? openPanel() : closePanel();
      });
      document.addEventListener('click', function (e) {
        if (!panel.hidden && !notif.contains(e.target)) closePanel();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) { closePanel(); toggle.focus(); }
      });

      updateBadge();
    }

    /* ---------- Carrousel d'annonces ---------- */
    var annonce = document.querySelector('[data-veji-annonce]');
    if (annonce) {
      var slides = annonce.querySelectorAll('[data-annonce-slide]');
      var prevBtn = annonce.querySelector('[data-annonce-prev]');
      var nextBtn = annonce.querySelector('[data-annonce-next]');
      if (slides.length > 1) {
        var idx = 0;
        var timer = null;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function show(i) {
          idx = (i + slides.length) % slides.length;
          slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        }
        function next() { show(idx + 1); }
        function prev() { show(idx - 1); }
        function start() {
          if (reduce || timer) return;
          timer = window.setInterval(next, 6000);
        }
        function stop() {
          if (timer) { window.clearInterval(timer); timer = null; }
        }
        function restart() { stop(); start(); }

        if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
        if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
        annonce.addEventListener('mouseenter', stop);
        annonce.addEventListener('mouseleave', start);

        show(0);
        start();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
